import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'components/ui/badge';
import type { Expertise } from 'api/referentialsApi';

/** Beyond this, the cell folds — a specialty with fifteen expertises would blow up its row. */
const VISIBLE = 3;

/**
 * Expertises of one specialty, folded past the third with a `+N` that expands in place. Shows
 * deactivated ones too: a display never filters on `is_active`, only the pickers do.
 */
const ExpertiseBadges = ({ expertises }: { expertises: Expertise[] }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (expertises.length === 0) {
    return <span className="text-sm text-gray-500">{t('No expertise')}</span>;
  }

  const hidden = expertises.length - VISIBLE;
  const shown = expanded ? expertises : expertises.slice(0, VISIBLE);

  return (
    <div className="flex flex-wrap items-center gap-1">
      {shown.map((expertise) => (
        <Badge key={expertise.id} variant={expertise.is_active ? 'secondary' : 'outline'}>
          {expertise.name}
        </Badge>
      ))}
      {hidden > 0 && (
        <button
          type="button"
          onClick={() => setExpanded((current) => !current)}
          className="rounded px-1.5 py-0.5 text-xs font-medium text-muted-foreground hover:text-foreground"
        >
          {expanded ? t('Show less') : t('+{{count}}', { count: hidden })}
        </button>
      )}
    </div>
  );
};

export default ExpertiseBadges;
